module.exports = __webpack_public_path__ + "img/Sama-Logo.b608a673.svg";